import styled from 'styled-components';

export const LeftBarLayout = styled.div`
  display: ${(props) => (props.isVisible ? 'grid' : 'none')};
  grid-template-rows: auto auto 1fr;
  padding: 0.5rem;
  gap: 0.5rem;
  border-right: 1px solid ${(props) => props.theme.palette.divider};
`;
